import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { IRange, IRangeField, rangeBases } from '@/ui-kit/table-filters/filters.type';
import { isBetween, isFrom, isTo } from '@/ui-kit/table-filters/RangeFilter';
import { ICardTransactionFilterFormFields } from '@/store/types/card-transactions.type';

export function mapCardTransactionAmount(value) {
  if (isFrom(value) && value.base === rangeBases.EQUAL) {
    return {
      amountFrom: value.from,
      amountTo: value.from,
    };
  } else if (isFrom(value) && value.base === rangeBases.MORE) {
    return { amountFrom: value.from };
  } else if (isTo(value)) {
    return { amountTo: value.to };
  } else if (isBetween(value)) {
    return {
      amountFrom: value.from,
      amountTo: value.to,
    };
  }
}

export function useCardTransactionAmountField(
  methods: UseFormReturn<ICardTransactionFilterFormFields>,
  onChange,
): IRangeField {
  const handleAmountChange = useCallback(
    (value: IRange) => {
      if (value.base === null && value.from === null && value.to === null) {
        methods.setValue('amount', value);
        onChange();
        return;
      }

      const currentValue = methods.getValues('amount');
      const newValue = { ...currentValue, ...value };
      methods.setValue('amount', newValue);

      if (isFrom(newValue) || isTo(newValue) || isBetween(newValue)) {
        onChange();
      }
    },
    [onChange, methods],
  );

  const amountValue = methods.watch('amount');

  return { value: amountValue, handleChange: handleAmountChange };
}
